import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=1e05ba42&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=1e05ba42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e05ba42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e05ba42')) {
      api.createRecord('1e05ba42', component.options)
    } else {
      api.reload('1e05ba42', component.options)
    }
    module.hot.accept("./TheHeader.vue?vue&type=template&id=1e05ba42&scoped=true", function () {
      api.rerender('1e05ba42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TheHeader/TheHeader.vue"
export default component.exports